import { useWindowSize } from "@/hooks/measurements";

export const ANALYTICS_MOBILE_MAX_PX = 767;
export const ANALYTICS_TABLET_MAX_PX = 991;

export function useAnalyticsMobile(): boolean {
  const { width } = useWindowSize();
  return width <= ANALYTICS_TABLET_MAX_PX;
}
